import { useEffect, useState } from "react";

export const PaginacionABEXA = ({
    data,
    setDataReturn,
    numeroFilas,
    retornarInicio
}) => {
    const [paginaActual, setPaginaActual] = useState(1);
    const ultimoIndice = paginaActual * numeroFilas;
    const primerIndice = ultimoIndice - numeroFilas;
    const totalPaginas = Math.ceil(data.length / numeroFilas);
    const numeroPaginas = new Array(totalPaginas).fill(0);

    
    useEffect(() => {
        retornarInicio && setPaginaActual(1)
        setDataReturn(data.slice(primerIndice,ultimoIndice))
    },[data])
    useEffect(() => {
        setDataReturn(data.slice(primerIndice,ultimoIndice))
    },[paginaActual])


    const cambioPaginaTeclado = (keycode) => {
        if(keycode === 39){
            if(paginaActual === totalPaginas){
                return;
            }
            setPaginaActual(paginaActual + 1)
        }
        if(keycode === 37){
            if(paginaActual === 1){
                return;
            }
            setPaginaActual(paginaActual - 1)
        }
    }
    return(
        <>
            <section className="flex p-2">
                {
                    numeroPaginas.length > 0 &&
                    <>
                        <button
                            key={'btnAtras'}
                            className="hover:bg-blue-500 rounded-full  px-2"
                            onClick={() => setPaginaActual(paginaActual - 1)}
                            disabled={paginaActual === 1}
                            >
                            <i className="fa fa-chevron-left"></i>
                        </button>
                        {
                            numeroPaginas.map((num,i) => (
                                <button
                                    key={num + '-btn_' + i}
                                    onKeyDown={(e)=> cambioPaginaTeclado(e.keyCode,e)}
                                    className={` rounded-[100%] w-[26px] h-[26px] mx-[1px]
                                        ${(i + 1) === paginaActual ? 
                                            ' active bg-blue-500 ring-1 ring-white'
                                            :
                                            '  bg-gray-800  hover:bg-blue-500 ring-0 '
                                        }`
                                    }
                                    onClick={() => setPaginaActual(i + 1)}
                                >
                                {i +1 }
                                </button>
                            ))
                        }
                        <button
                            key={'btnAdelanto'}
                            className="hover:bg-blue-500 rounded-full  px-2  "
                            onClick={() => setPaginaActual(paginaActual + 1)}
                            disabled={paginaActual === totalPaginas}
                        >
                            <i className="fa fa-chevron-right" aria-hidden="true"></i>
                        </button>
                    </>
                }
            </section>
        </>
    )
}